import { Vector2 } from "../../common/vector2.js";
import { Easing } from "../../transforms/transform_base.js";
import { TransformOpacity } from "../../transforms/transform_opacity.js";
import { TransformScale } from "../../transforms/transform_scale.js";
import { TransformStraightMove } from "../../transforms/transform_straight_move.js";
import { UIElement } from "../common_ui_elements/ui_element.js";

export interface AppearPopOptions
{
  from_scale?: number;
  overshoot?: number;
  duration_ms?: number;
}

export class OverlayAppear
{
  public static readonly DURATION_MS = 220;
  public static readonly SETTLE_MS = 130;
  public static readonly FROM_SCALE = 0.8;
  public static readonly RISE_DESIGN_PX = 40;

  public static pop( el: UIElement | null, start_time: number, options: AppearPopOptions = {} ): void
  {
    if ( !el )
      return;

    const duration = options.duration_ms ?? OverlayAppear.DURATION_MS;
    const from_scale = options.from_scale ?? OverlayAppear.FROM_SCALE;
    const overshoot = options.overshoot ?? 1;
    const from = new Vector2( from_scale, from_scale );
    const peak = new Vector2( overshoot, overshoot );
    const normal = new Vector2( 1, 1 );

    el.setOpacityImmediate( 0 );
    el.setScaleImmediate( from );

    el.addTransform( new TransformOpacity( el, true, 0, 1, start_time, duration, { easing: Easing.EaseOutQuad } ) );
    el.addTransform( new TransformScale( el, true, from, peak, start_time, duration, { easing: Easing.EaseOutQuad } ) );

    if ( overshoot === 1 )
      return;

    const settle_start = start_time + duration;
    el.addTransform( new TransformScale( el, true, peak, normal, settle_start, OverlayAppear.SETTLE_MS, { easing: Easing.EaseInOutQuad } ) );
  }

  public static rise( el: UIElement | null, start_time: number, rise_design_px = OverlayAppear.RISE_DESIGN_PX, duration_ms = OverlayAppear.DURATION_MS ): void
  {
    if ( !el )
      return;

    const final_pos = el.pixelPosImportant().clone();
    const start_pos = final_pos.clone();
    start_pos.y += LayoutScaler.heightFromDesign( rise_design_px );

    el.setOpacityImmediate( 0 );
    el.setPixelPos( start_pos, true );

    el.addTransform( new TransformOpacity( el, true, 0, 1, start_time, duration_ms, { easing: Easing.EaseOutQuad } ) );
    el.addTransform( new TransformStraightMove( el, true, start_pos, final_pos, start_time, duration_ms, { easing: Easing.EaseOutQuad } ) );
  }
}
